import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";
import { NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DEFAULTS } from "common/config";
import {
  LABELS,
  WARNINGS,
  TITLES,
  SUCCESS,
  ERRORS,
  SUB_TITLES,
} from "common/lables";
import { COMMON_JS } from "common/scripts";

import { GEO_APIs } from "apihandlers/geography";
import { CUSTOMER_APIs } from "apihandlers/customer";
import { TRANS_APIs } from "apihandlers/transaction";

const Payment = (props: any) => {
  const { setDashMenu } = props;

  const customerRef: any = useRef(null);
  const areasRef: any = useRef(null);

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [customers, setCustomers] = useState<any>(null);
  const [areas, setAreas] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "customerName",
      name: LABELS.CUSTOMER,
      width: "35%",
      type: "text",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "amount",
      name: LABELS.AMOUNT,
      width: "35%",
      type: "text",
      align: "center",
      editable: false,
      searchable: true,
      sortable: true,
    },
    {
      key: "remarks",
      name: LABELS.REMARKS,
      width: "10%",
      type: "number",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "mode",
      name: LABELS.PAYMENT_MODE,
      width: "10%",
      type: "dropdown",
      filters: [
        {
          id: "cash",
          name: "Cash",
        },
        {
          id: "upi",
          name: "Upi",
        },
        {
          id: "bank",
          name: "Bank",
        },
        {
          id: "card",
          name: "Card",
        },
      ],
      editable: "false",
      sortable: "true",
      searchable: "true",
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (loading) {
      getRoutes();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await TRANS_APIs.getPayments(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getRegions:", error);
    }
  };

  const getRoutes = () => {
    const args = {
      activeStatus: true,
    };
    GEO_APIs.getAreas(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.areaName,
          };
        });
        setAreas(list);
        getCustomers();
      }
    });
  };

  const getCustomers = (areaId = null) => {
    const args = {
      activeStatus: true,
      areaId,
      //minResponse: true,
    };
    CUSTOMER_APIs.getCustomerProfiles(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setCustomers(list);
        getRows();
      }
    });
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };

  const managePayment = () => {
    const remarks = (
      document.getElementById("remarks") as HTMLInputElement
    ).value.trim();
    const customerId = customerRef.current.selectedValue.id;
    const amount = (
      document.getElementById("amount") as HTMLInputElement
    ).value.trim();
    let active = document.querySelector(
      'input[name="mode"]:checked'
    ) as HTMLInputElement;
    const selectBtnValue = active ? active.value : "";

    const errors = [];
    if (amount === "") {
      errors.push({
        id: "amount",
        msg:
          "<span class='bold'>" +
          LABELS.AMOUNT +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (remarks === "") {
      errors.push({
        id: "remarks",
        msg:
          "<span class='bold'>" +
          LABELS.REMARK +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!customerId) {
      errors.push({
        id: "customerId",
        msg:
          "<span class='bold'>" +
          LABELS.CUSTOMER +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!selectBtnValue) {
      errors.push({
        id: "selectBtnValue",
        msg:
          "<span class='bold'>" +
          LABELS.PAYMENT_MODE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      customerId: customerId,
      amount,
      remarks,
      billDetail: {
        billDate: "",
        refNumber: "",
      },
      mode: selectBtnValue,
    };
    setIsSubmit(true);
    TRANS_APIs.managePayment(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  const onHandelChange = (e, f) => {
    if (f.id) {
      getCustomers(f.id);
    }
  };

  console.log("Page: Region:");

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.PAYMENT} </li>
        </ul>
        <h4>{TITLES.PAYMENT}</h4>
        <p>{SUB_TITLES.PAYMENT}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={"payment"}
            height={window.innerHeight * 0.8}
            cols={columns}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.REGION}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.PAYMENT + ": " + selectedRow.id
              : "Add New " + LABELS.PAYMENT
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup ">
            <label>{LABELS.ROUTE}</label>
            <AutoComplete
              list={areas}
              childRef={areasRef}
              defaultValue={
                selectedRow.routeId
                  ? {
                      id: selectedRow.routeId,
                      label: selectedRow.routeName,
                    }
                  : null
              }
              onChange={onHandelChange}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup required">
            <label>
              {LABELS.CUSTOMER}
              {<span>*</span>}
            </label>
            <AutoComplete
              list={customers}
              childRef={customerRef}
              defaultValue={
                selectedRow.id
                  ? {
                      id: selectedRow.customerId,
                      label: selectedRow.customerName,
                    }
                  : null
              }
              onChange={(e, v) => {}}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup red">
            <TxtRow
              id={"amount"}
              type={"number"}
              label={LABELS.AMOUNT}
              required={true}
              defaultValue={selectedRow.amount}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <TxtRow
              id={"remarks"}
              type={"text"}
              required={true}
              label={LABELS.REMARKS}
              defaultValue={selectedRow.amount}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup required">
            <label>
              {LABELS.PAYMENT_MODE}
              {<span>{" *"}</span>}
            </label>
            <RadioBtn
              list={[
                {
                  id: "cash",
                  label: LABELS.CASH,
                  value: LABELS.CASH,
                  checked: selectedRow.id ? selectedRow.mode === "cash" : true,
                  disabled: false,
                },
                {
                  id: "bank",
                  label: LABELS.BANK,
                  value: LABELS.BANK,
                  checked: selectedRow.id ? selectedRow.mode === "bank" : false,
                  disabled: false,
                },
                {
                  id: "upi",
                  label: LABELS.UPI,
                  value: LABELS.UPI,
                  checked: selectedRow.id ? selectedRow.mode === "upi" : false,
                  disabled: false,
                },
                {
                  id: "card",
                  label: LABELS.CARD,
                  value: LABELS.CARD,
                  checked: selectedRow.id ? selectedRow.mode === "card" : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"mode"}
              disabled={isSubmit}
            />
          </div>
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          <div className="formGroup submitBtnWrapper">
            <div className="flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                loading={isSubmit}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={managePayment}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Payment);
